// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eGuE7","index":"styles_index__37kzV"};